export const VERIFIED_APP_VERSIONS = {
  CAREER_NAVER_LICENSE: 'CAREER_NAVER_LICENSE', // 네이버 자격증 연동 지원 앱 버전
  COVER_LETTER_AD_EDUCATION: 'COVER_LETTER_AD_EDUCATION', // 자만검 상세 배너 및 공고 상세 추천 교육 공고 영역 지원 앱 버전
  SCRAP_USER_STATISTICS: 'SCRAP_USER_STATISTICS', // 공고 상세 관심 유저 통계 영역 지원 앱 버전
  TEAM_RECRUIT: 'TEAM_RECRUIT', // 팀원 모집 영역 지원 앱 버전
  COMPANY_INFO: 'COMPANY_INFO', // 기업정보 더보기 버튼 지원 앱 버전
} as const

export type TAppversionSemver = `${string}.${string}.${string}`

type TAppVersion = {
  [key in keyof typeof VERIFIED_APP_VERSIONS]: TAppversionSemver
}

export const IOS_APP_VERSIONS: TAppVersion = {
  CAREER_NAVER_LICENSE: '1.22.0',
  COVER_LETTER_AD_EDUCATION: '1.24.1',
  SCRAP_USER_STATISTICS: '1.29.0',
  TEAM_RECRUIT: '1.46.0',
  COMPANY_INFO: '2.1.0',
} as const

export const AOS_APP_VERSIONS: TAppVersion = {
  CAREER_NAVER_LICENSE: '1.22.0',
  COVER_LETTER_AD_EDUCATION: '1.24.1',
  SCRAP_USER_STATISTICS: '1.29.0',
  TEAM_RECRUIT: '1.46.0',
  COMPANY_INFO: '2.1.0',
} as const
